/* import __COLOCATED_TEMPLATE__ from './build-for-modal.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export type ProcedureChannelType = 'text' | 'voice';

interface Signature {
  Args: {
    isOpen: boolean;
    onContinue: (channelType: ProcedureChannelType) => void;
    onClose: () => void;
    isPending?: boolean;
  };
}

const CHANNEL_OPTIONS: ProcedureChannelType[] = ['text', 'voice'];

export default class BuildForModal extends Component<Signature> {
  @tracked channelType: ProcedureChannelType = 'text';

  @action
  selectChannel(channel: ProcedureChannelType) {
    this.channelType = channel;
  }

  @action
  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      event.preventDefault();
      this.moveSelection(1);
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      event.preventDefault();
      this.moveSelection(-1);
    }
  }

  private moveSelection(direction: number) {
    let currentIndex = CHANNEL_OPTIONS.indexOf(this.channelType);
    let nextIndex = (currentIndex + direction + CHANNEL_OPTIONS.length) % CHANNEL_OPTIONS.length;
    this.channelType = CHANNEL_OPTIONS[nextIndex];

    let selector = `[data-test-build-for-${this.channelType}-option]`;
    (document.querySelector(selector) as HTMLElement)?.focus();
  }

  @action
  handleContinue() {
    this.args.onContinue(this.channelType);
  }

  @action
  handleClose() {
    this.channelType = 'text';
    this.args.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Procedures::BuildForModal': typeof BuildForModal;
    'fin-ai-agent/procedures/build-for-modal': typeof BuildForModal;
  }
}
